// extracted by mini-css-extract-plugin
export default {"price":"L4-z","onSale":"M4-z","msrpLabelPrice":"N4-z","msrpLabel":"O4-z","originalPrice":"P4-z","percentOff":"Q4-z"};